import { render } from "./presenters.vue?vue&type=template&id=eaa6d4a0&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=eaa6d4a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eaa6d4a0"

export default script